import { withLocalState } from 'pyradux';

import PaymentDetailsContainer from './PaymentDetails.container';
import reducer from './PaymentDetails.reducer';

const withLocalStateOptions = {
  reducer,
  stateKey: 'paymentDetails',
  sagas: [],
};

export default withLocalState(withLocalStateOptions, PaymentDetailsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/PaymentDetails/index.js